import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { ReferenceEntity } from "src/app/static-data/models/interfaces/static-data";

@Injectable({
    providedIn: 'root'
})
export class CreditProvisionService {

    selectedReferenceEntities$ = new ReplaySubject<ReferenceEntity[]>();

    constructor() {

    }
}